(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ds-announcement-bar')) {
    customElements.define('ds-announcement-bar', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.ds-announcements__item'));
        if (!this.items.length) return;

        this.index = 0;
        this.paused = false;
        this.editorPaused = false;
        this.mobile = window.matchMedia('(max-width: 768px)');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const sync = () => {
          this.show(this.index);
          this.schedule();
        };

        this.mobile.addEventListener('change', sync, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => this.schedule());
        }, options);
        this.querySelector('.ds-announcements__toggle')?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.querySelector('[data-announcement-pause]').hidden = this.paused;
          this.querySelector('[data-announcement-play]').hidden = !this.paused;
          this.schedule();
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.items.indexOf(event.target.closest('.ds-announcements__item'));
          if (index < 0) return;
          event.stopPropagation();
          this.editorPaused = true;
          this.show(index);
          this.schedule();
        }, options);
        this.addEventListener('shopify:block:deselect', (event) => {
          event.stopPropagation();
          this.editorPaused = false;
          this.schedule();
        }, options);

        this.setAttribute('data-rotation-ready', '');
        sync();
      }

      show(index) {
        this.index = index;
        this.items.forEach((item, itemIndex) => {
          const visible = !this.mobile.matches || itemIndex === index;
          item.classList.toggle('is-active', itemIndex === index);
          item.toggleAttribute('inert', !visible);
          if (visible) item.removeAttribute('aria-hidden');
          else item.setAttribute('aria-hidden', 'true');
        });
      }

      schedule() {
        window.clearInterval(this.timer);
        if (!this.isConnected || !this.mobile.matches || this.items.length < 2 ||
          this.paused || this.editorPaused || document.hidden || this.contains(document.activeElement)) return;

        this.timer = window.setInterval(() => {
          this.show((this.index + 1) % this.items.length);
        }, 5000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-freshness-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ds-freshness-dialog')) {
    customElements.define('ds-freshness-dialog', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          if (event.target.closest('[data-ds-freshness-close]')) this.dialog.close();
        }, options);
        this.dialog.addEventListener('pointerdown', event => {
          this.backdropPointer = this.isBackdrop(event);
        }, options);
        this.dialog.addEventListener('click', event => {
          if (this.backdropPointer && this.isBackdrop(event)) this.dialog.close();
          this.backdropPointer = false;
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const controls = this.dialog.querySelectorAll('a[href], button:not([disabled])');
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.toggle('ds-freshness-open', !!document.querySelector('.ds-freshness[open]'));
          if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-ds-freshness-open]');
          if (!trigger || trigger.getAttribute('aria-controls') !== this.dialog.id) return;
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.trigger = trigger;
          if (!this.dialog.open) this.dialog.showModal();
          this.dialog.querySelector('.ds-freshness__scroll').scrollTop = 0;
          document.documentElement.classList.add('ds-freshness-open');
        }, options);
      }
      isBackdrop(event) {
        if (event.target !== this.dialog) return false;
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.dialog?.open) this.dialog.close();
        document.documentElement.classList.toggle('ds-freshness-open', !!document.querySelector('.ds-freshness[open]'));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
